import React from 'react';
import whatsappImage from '../../public/whatsappImage.png';
import Image from '@/shared/Image';
import Link from '@/shared/Link';
import isAuthenticatedRoute from '@/utils/isAuthenticatedRoute';
import { ECOM_CART_URL, ECOM_CC_AGENT, LOGIN_URL } from '@/configs/constants';

const WHATSAPP_URL = 'https://api.whatsapp.com/send?phone=917039883333&text=Hi';
interface WhatsappButtonProps {
  isLoggedIn?: boolean;
  pathname?: string;
  isFlutterClient?: boolean;
  isSCAClient?: boolean;
}

const WhatsappButton = ({
  pathname = '',
  isFlutterClient,
  isSCAClient = false,
}: WhatsappButtonProps) => {
  if (
    isAuthenticatedRoute(pathname) ||
    pathname.startsWith(ECOM_CART_URL) ||
    pathname.startsWith(LOGIN_URL) ||
    pathname.startsWith(ECOM_CC_AGENT) ||
    pathname.startsWith('/ecom/payment') ||
    pathname.startsWith('/amc/select-duration') ||
    pathname.startsWith('/seller') ||
    isFlutterClient ||
    isSCAClient
  )
    return null;

  return (
    <Link href={WHATSAPP_URL} target="_blank">
      <Image className="w-full h-full" src={whatsappImage.src} alt="WhatsappButton" />
    </Link>
  );
};

export default WhatsappButton;
